<ul class="text-subtitle">
  <li class="originalprice">
    Originele prijs:
    <app-currency [value]="product.original_price"/>
  </li>
  <li class="discount">
    Korting:
    <app-currency [value]="product.discounted_price"/>
  </li>
  <li class="newprice">
    Nieuwe Prijs:
    <app-currency [value]="product.price"/>
  </li>
</ul>
